import React from "react";
import styled from "@emotion/styled";
import mq from "../utils/mediaQueries";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  ${mq("sm")} {
    align-items: start;
    text-align: start;
  } ;
`;

const DataEntry = ({ title, subtitle, content }) => {
  return (
    <Wrapper>
      {title && <h1>{title}</h1>}
      {subtitle && <p>{subtitle}</p>}
      {content && <p>{content}</p>}
    </Wrapper>
  );
};

export default DataEntry;
